export function is<A, B extends A>(
  fn: (a: A) => B | undefined
): (a: A) => a is B {
  return (a: A): a is B => typeof fn(a) !== 'undefined';
}
